import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    section {
      display: flex;
      justify-content: center;
      width: 100%;
      border-bottom: var(--nav-border-style);
      height: calc(50rem / var(--default-rem-px-count));
      align-items: center;
    }

    form {
      background-color: white;
      display: flex;
      flex-direction: row;
      width: 100%;
    }

    input {
      border: none;
      width: -webkit-fill-available;
      padding-left: calc(10rem / var(--default-rem-px-count));
      font-size: max(1rem, 16px);
      line-height: calc(32rem / var(--default-rem-px-count));
      letter-spacing: -0.21px;
    }

    input:focus {
      outline: none;
    }

    img {
      width: calc(12rem / var(--default-rem-px-count));
      height: calc(12rem / var(--default-rem-px-count));
      padding: 12px;
    }

    .visually-hidden {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      border: 0;
    }

    .close-search {
      display: none;
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      color: inherit;
    }

    .close-search:focus-visible {
      outline: 2px solid #222222;
      outline-offset: -2px;
    }

    @media (min-width: 1024px) {
      section {
        border-bottom: none;
        height: inherit;
      }

      form {
        width: calc(667rem / var(--default-rem-px-count));
        justify-content: space-between;
      }

      input {
        font-size: calc(14rem / var(--default-rem-px-count));
      }

      .close-search {
        display: inherit;
        cursor: pointer;
      }
    }
  `,
];
